import { gql } from '@apollo/client';

import { ADDRESS_FRAGMENT } from '../fragments';
import { CRM_LINK } from '../fragments/crmLink';

export const ORGANIZATION_LIST_ITEM_FRAGMENT = gql`
  fragment organizationListItemFragment on OrganizationListItem {
    id
    name
    status
    baymaxEnabled
    adAccountsCount
    usersCount
    createdAt
    lastLoginAt
    campaignsCount
    totalSpent
    activeCampaignsCount
    crmLink {
      ...crmLink
    }
  }
  ${CRM_LINK}
`;

export const ORGANIZATION_FRAGMENT = gql`
  fragment organizationFragment on Organization {
    name
    status
    id
    disabledReason
    phoneNumber
    operatesAsAgency
    isBaymaxEnabled
    createdAt
    lastLoginAt
    threepBillingEligible
    address {
      ...addressFragment
    }
    crmLink
  }
  ${ADDRESS_FRAGMENT}
`;
